import Common from "../../../../Common";
import AclGroup from "./usersetting/AclGroup";
import Device from "./usersetting/Device";
import Queue from "./usersetting/Queue";
import RingGroup from "./usersetting/RingGroup";

interface CreateBody {
	name: string
}

interface ApplyBody {
	pbx_user_id: id
}

const UserSetting = class extends Common {
	aclGroup: InstanceType<typeof AclGroup>;
	device: InstanceType<typeof Device>;
	queue: InstanceType<typeof Queue>;
	ringgroup: InstanceType<typeof RingGroup>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.aclGroup = new AclGroup(headers);
		this.device = new Device(headers);
		this.queue = new Queue(headers);
		this.ringgroup = new RingGroup(headers);
	}

	read = (companyId: id, templateId: id, id: id) =>
		this.get(`/company/${companyId}/templates/usersettings/${templateId}/template/${id}`)

	browse = (companyId: id, templateId: id) =>
		this.get(`/company/${companyId}/templates/usersettings/${templateId}/template`)

	create = (companyId: id, templateId: id, body: CreateBody) =>
		this.post(`/company/${companyId}/templates/usersettings/${templateId}/template`, body)

	update = (companyId: id, templateId: id, id: id, body: CreateBody) =>
		this.patch(`/company/${companyId}/templates/usersettings/${templateId}/template/${id}`, body)

	delete = (companyId: id, templateId: id, id: id) =>
		this.doDelete(`/company/${companyId}/templates/usersettings/${templateId}/template/${id}`)

	apply = (companyId: id, templateId: id, id: id, body: ApplyBody) =>
		this.post(`/company/${companyId}/templates/usersettings/${templateId}/template/${id}/apply`, body)
}

export default UserSetting
